import { useEffect, useCallback, memo } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useDispatch, useSelector } from 'react-redux';
import { getBanners } from 'legacyfrontend/redux/actions/banners-actions';
import { selectBannersState } from 'legacyfrontend/redux/selectors/application-selectors';
import LoadSpinner from '../spinner';
import BannerHoverx4 from './bannerComponents/BannerHoverx4';
import BannerSimpleX3 from './bannerComponents/BannerSimpleX3';
import Carousel3 from './bannerComponents/Carousel3';
import CarouselBanners from './bannerComponents/CarouselBanners';
import FeaturedSeventyFiveTwentyFive from './bannerComponents/FeaturedSeventyFiveTwentyFive';
import Featuredx2 from './bannerComponents/Featuredx2';
import FullWidthBanner from './bannerComponents/FullWidthBanner';
import OffersGalery from './bannerComponents/OffersGalery';
import VideoBanner from './bannerComponents/video';

function getComponentByUbication(component, ubicacionObj, componentIndex, ubicacionIndex) {
  const componentsMap = {
    'destacado-2-lugares-75-25': FeaturedSeventyFiveTwentyFive,
    '2-banner-ancho-total': Featuredx2,
    'galeria-ofertas': OffersGalery,
    'banner-zocalo-x3': BannerSimpleX3,
    'carrusel-4-elementos': CarouselBanners,
    'carrusel-3-elementos': Carousel3,
    video: VideoBanner,
    'banner-simple-ancho-total': FullWidthBanner,
    'banner-hover-x4': BannerHoverx4,
  };

  const categoryName = component.categoria.nombre;
  const ubicationName = ubicacionObj?.nombre;
  const TheComponent = componentsMap[ubicationName];

  return (
    TheComponent !== undefined && (
      <TheComponent
        key={`${ubicationName}-${categoryName}-${component.banner[0].id}-${
          ubicacionObj.id
        }-${componentIndex}${ubicacionIndex !== undefined ? `-${ubicacionIndex}` : ''}`}
        data={component}
      />
    )
  );
}

function mapComponent(component, index) {
  if (component.categoria?.ubicacion) {
    const result = Array.isArray(component.categoria.ubicacion)
      ? component.categoria.ubicacion.map((ubicacion, ubicacionIndex) =>
          getComponentByUbication(component, ubicacion, index, ubicacionIndex)
        )
      : getComponentByUbication(component, component.categoria.ubicacion, index);

    return result;
  }
  return null;
}

const MainCarousel = ({ defaultB = true, id, defaultOnly, showHomeOnly }) => {
  const dispatch = useDispatch();

  const fetchBanners = useCallback(() => {
    dispatch(getBanners({ id, esDefault: defaultB, defaultOnly, showHomeOnly }));
  }, [dispatch, id, defaultB, defaultOnly, showHomeOnly]);

  useEffect(() => {
    fetchBanners();
  }, [fetchBanners]);

  const { categoriesMainCarousel, ready, error } = useSelector(selectBannersState);

  if (!ready) {
    return (
      <div className='w-full object-cover h-[600px] md:h-[450px] sm:h-[300px] bg-gray-100 relative flex justify-center items-center'>
        <LoadSpinner />
      </div>
    );
  }

  if (error || !categoriesMainCarousel || categoriesMainCarousel.length === 0) {
    return null;
  }

  const validCategories = categoriesMainCarousel.filter(
    (component) => component.banner && component.banner.length > 0
  );

  if (validCategories.length === 0) {
    return null;
  }

  let theComponents = [];
  validCategories.forEach((component, index) => {
    theComponents = theComponents.concat(mapComponent(component, index));
  });

  return <div className='pt-10 pb-10 px-2 md:px-10'>{theComponents}</div>;
};

export default MainCarousel;
